import { render } from "./AdditionalMaengel.vue?vue&type=template&id=981ba83c&ts=true"
import script from "./AdditionalMaengel.vue?vue&type=script&lang=ts"
export * from "./AdditionalMaengel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__